export default __webpack_public_path__ + "static/loupe-navigation_h265-41fdaf513e936266fe95808dbc6c0c55.mp4";